import { BLOG_SLUG } from "../core/urls";
import Box from "./Box";
import BoxWithGutter from "./BoxWithGutter";
import MediumLink from "./MediumLink";
import PropTypes from "prop-types";
import React from "react";
import Text from "./Text";

function BlogArticleHeader({ title, published }) {
  const href = `/${BLOG_SLUG}`;
  return (
    <Box borderBottom="1px solid black" pt={100} pb={[30, null, 70, null]}>
      <BoxWithGutter>
        <MediumLink href={href} text="Back" back />
        <Text
          mt={40}
          as="h1"
          uppercase
          fontSize={[26, 44, 62, 62]}
          lineHeight={1}
        >
          {title}
        </Text>
        {published && (
          <Text
            uppercase
            fontFamily="ibmPlexMono"
            fontSize={12}
            fontWeight={500}
            mt={12}
          >
            {published}
          </Text>
        )}
      </BoxWithGutter>
    </Box>
  );
}

export default BlogArticleHeader;

BlogArticleHeader.propTypes = {
  title: PropTypes.string.isRequired,
  published: PropTypes.string,
};
